<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.user_profile}}</span>
        <span
          v-if="mData.viewMode == 'update' || mData.viewMode == 'changePass' || mData.viewMode == 'changeRole'"
        >{{aLang.c_update}} {{aLang.user_profile}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.user_profile}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col
              md="3"
              v-if="mData.viewMode == 'create' || mData.viewMode == 'changePass' || mData.viewMode == 'changeRole'"
            >
              <el-form-item label="Tên tài khoản (tên đăng nhập)" prop="account.account">
                <el-input
                  v-model="mData.dataForm.account.account"
                  autocomplete="off"
                  auto-complete="off"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'changePass' || mData.viewMode == 'changeRole'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="mData.viewMode == 'create' || mData.viewMode == 'changePass'">
              <el-form-item label="Mật khẩu" prop="account.password">
                <el-input
                  v-model="mData.dataForm.account.password"
                  :disabled="mData.viewMode == 'detail'"
                  autocomplete="off"
                  auto-complete="off"
                  show-password
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="mData.viewMode == 'create' || mData.viewMode == 'changePass'">
              <el-form-item label="Nhập lại mật khẩu" prop="account.repassword">
                <el-input
                  v-model="mData.dataForm.account.repassword"
                  :disabled="mData.viewMode == 'detail'"
                  show-password
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="mData.viewMode == 'create' || mData.viewMode == 'changeRole'">
              <el-form-item label="Quyền sử dụng" prop="account.roles">
                <el-select
                  v-model="mData.dataForm.account.roles"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  @change="mData.dataForm.account.roles.includes('PVHTT') ? fn_changeProvince(mData.dataForm.vhtt.province_id) : ''"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.accountRolesCreate"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              md="2"
              v-if="mData.viewMode == 'create' || mData.viewMode == 'update' || mData.viewMode == 'detail'"
            >
              <el-form-item :label="aLang.user_profile_avatar" prop="profile.avatar_id">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="aRole('SafePlace') || mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 && !aRole('SafePlace') ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col
              :md="mData.viewMode == 'create' || mData.viewMode == 'update' || mData.viewMode == 'detail' ? '10' : '12'"
            >
              <b-row  v-if="mData.viewMode == 'create' || mData.viewMode == 'update' || mData.viewMode == 'detail'">
                <b-col md="4">
                  <el-form-item :label="aLang.user_profile_fullname" prop="profile.ho_ten.ho_ten">
                    <el-input
                      v-model="mData.dataForm.profile.ho_ten.ho_ten"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.user_profile_phone_number" prop="profile.dien_thoai">
                    <el-input
                      v-model="mData.dataForm.profile.dien_thoai"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail' || mData.isSafePlace"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.user_profile_email" prop="profile.email">
                    <el-input
                      v-model="mData.dataForm.profile.email"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                  md="3"
                  v-if="mData.viewMode == 'create' || mData.viewMode == 'update' || mData.viewMode == 'detail'"
                >
                  <el-form-item :label="aLang.user_profile_gender" prop="profile.gioi_tinh">
                    <el-select
                      v-model="mData.dataForm.profile.gioi_tinh"
                      :placeholder="aLang.c_select"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listGioiTinh"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3" v-if="mData.viewMode == 'create' || mData.viewMode == 'changeRole'">
                  <el-form-item
                    :label="aLang.user_vhtt_province"
                    prop="vhtt.province_id"
                    v-if="mData.dataForm.account.roles.includes('SVHTT') || mData.dataForm.account.roles.includes('PVHTT')"
                  >
                    <el-select
                      v-model="mData.dataForm.vhtt.province_id"
                      :placeholder="aLang.c_select"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail'"
                      @change="mData.dataForm.account.roles.includes('PVHTT') ? fn_changeProvince(mData.dataForm.vhtt.province_id) : ''"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listProvince"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3" v-if="mData.viewMode == 'create' || mData.viewMode == 'changeRole'">
                  <el-form-item
                    :label="aLang.user_vhtt_district"
                    prop="vhtt.district_id"
                    v-if="mData.dataForm.account.roles.includes('PVHTT')"
                  >
                    <el-select
                      v-model="mData.dataForm.vhtt.district_id"
                      :placeholder="aLang.c_select"
                      :disabled="!mData.RecordIsCurrentUser && !aRole('Admin') && !aRole('Officer') || mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listDistrict"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm()"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="primary"
              @click="fn_submitForm()"
              v-ladda
              v-if="fn_showButtonUpdate()"
            >{{aLang.c_update}}</el-button>
            <!-- Chỉ hiển thị button update khi ở view update và quyền admin,Officer hoặc là người đăng nhập tự sửa bản ghi của họ -->


          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DataService from "../../../service/DataService";
import NguoiDungModel from "./NguoiDungModel";
import AccountApi from "../../../moduleApi/AccountApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import KhachDuLichApi from '@/moduleApi/KhachDuLichApi';
import HuongDanVienApi from '@/moduleApi/HuongDanVienApi';
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import ProvinceApi from '../../../moduleApi/ProvinceApi';
import DistrictApi from '../../../moduleApi/DistrictApi';
import UserSVHTTApi from '../../../moduleApi/UserSVHTTApi';
import UserPVHTTApi from '../../../moduleApi/UserPVHTTApi';

export default {
  data() {
    let gioiTinh = [{
      id: 1,
      text: LanguageService.lang.user_profile_gender_female
    },
    {
      id: 2,
      text: LanguageService.lang.user_profile_gender_male
    },
    {
      id: 3,
      text: LanguageService.lang.user_profile_gender_NA
    },
    {
      id: 4,
      text: LanguageService.lang.user_profile_gender_other
    }
    ];
    return {
      aLang: LanguageService.lang,
      aRole: MethodService.checkRole,
      mData: {
        viewMode: "create",
        moduleName: "NguoiDung",
        RecordIsCurrentUser: false,
        dataDefault: {
          accountRolesCreate: DataService.accountRolesCreate,
          listGioiTinh: gioiTinh,
          listProvince: [],
          listDistrict: []
        },
        dataForm: MethodService.copyObject(NguoiDungModel.dataForm),
        validForm: NguoiDungModel.validForm,
        fileUploadOption: {
          AnhDaiDien: MethodService.copyObject(
            NguoiDungModel.fileUploadOption.AnhDaiDien
          )
        },
        isSafePlace: false
      }
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);

          if (this.mData.viewMode == "create") {
            if (data.account.password != data.account.repassword) {
              window.toastr.warning("Mật khẩu và nhập lại mật khẩu không khớp");
              MethodService.stopLadda();
              return false;
            }
            data.account.roles.push("User");
            let resAccount = await AccountApi.create(data.account);
            data.profile.id = resAccount.result;
            await ProfileApi.create(data.profile);
            data.vhtt.id = resAccount.result;
            if(this.mData.dataForm.account.roles.includes('SVHTT')){
              delete data.vhtt.district_id;
              console.log(data.vhtt);
              await UserSVHTTApi.create(data.vhtt)
            }
            if(this.mData.dataForm.account.roles.includes('PVHTT')){
              console.log(data.vhtt);
              await UserPVHTTApi.create(data.vhtt)
            }
            // this.fn_resetForm();
            this.fn_go();
          }
          if (this.mData.viewMode == "update") {
            data.profile.id = this.$router.currentRoute.params.id;
            await ProfileApi.update(data.profile);
            this.fn_go();
          }
          if (this.mData.viewMode == "changePass") {
            if (data.account.password != data.account.repassword) {
              window.toastr.warning("Mật khẩu và nhập lại mật khẩu không khớp");
              MethodService.stopLadda();
              return false;
            }
            await AccountApi.update(data.account);
            if (this.mData.isSafePlace){
              DiemDenAnToanApi.clearCache();
            }
            this.fn_go();
          }
          if (this.mData.viewMode == "changeRole") {
            if (data.account.roles.indexOf("User") == -1) {
              data.account.roles.push("User");
            }
            await AccountApi.update(data.account);
            data.vhtt.id = this.mData.dataForm.vhtt.id;
            if(data.account.roles.includes("SVHTT")){
              await UserSVHTTApi.update(data.vhtt)
            }
            if(data.account.roles.includes("PVHTT")){
              await UserPVHTTApi.update(data.vhtt)
            }
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.fileUploadOption.AnhDaiDien = MethodService.copyObject(
        NguoiDungModel.fileUploadOption.AnhDaiDien
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },

    async fn_getDataById(id) {
      if (
        this.mData.viewMode == "changePass" ||
        this.mData.viewMode == "changeRole"
      ) {
        let resAccount = await AccountApi.findById(id);
        this.mData.dataForm.account = resAccount.result;
        if(
          this.mData.dataForm.account.roles.includes("SVHTT")
        ){
          const userSVHTTRes = await UserSVHTTApi.findById(id);
          this.mData.dataForm.vhtt = userSVHTTRes.result;
        }
        if(
          this.mData.dataForm.account.roles.includes("PVHTT")
        ){
          const userPVHTTRes = await UserPVHTTApi.findById(id);
          this.mData.dataForm.vhtt = userPVHTTRes.result;
          if(this.mData.dataForm.vhtt.province_id){
            const districtApi = await DistrictApi.list({
              limit: 100,
              filters: "provinceId="+this.mData.dataForm.vhtt.province_id
            })
            this.mData.dataDefault.listDistrict = districtApi.result;
          }
        }
      } else {
        let res = await ProfileApi.findById(id);
        let resKDL = await KhachDuLichApi.findById(id);
        let resHDV = await HuongDanVienApi.findById(id);
        // let resData = await this.fn_changeData(res.result);
        let avatarUrl = null;
        let resAccount = await DiemDenAnToanApi.list({filters: 'nguoi_tao_id=' + id, fields: "thong_tin_chung.anh"});
        if (resAccount.result && resAccount.result.length) {
          avatarUrl = resAccount.result[0].thong_tin_chung && resAccount.result[0].thong_tin_chung.anh
            ? ExtensionService.urlImg + resAccount.result[0].thong_tin_chung.anh
            : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
          let data = {
            id: undefined,
            name: "",
            url: avatarUrl
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          this.mData.isSafePlace = true;
        }
        if (res.result) {
          if (!avatarUrl) {
            let data = {
              id: res.result.avatar_id,
              name: res.result.avatar_id,
              url: avatarUrl || ExtensionService.urlImg + res.result.avatar_id
            };
            this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          }
          if (!res.result.ho_ten) {
            res.result.ho_ten = MethodService.copyObject(
              NguoiDungModel.dataForm.profile.ho_ten
            );
          }
          this.mData.dataForm.profile = res.result;
          if(!this.mData.dataForm.profile.ho_ten || (!this.mData.dataForm.profile.ho_ten.ho_ten && this.mData.viewMode == "detail")){
            this.mData.dataForm.profile.ho_ten ={
              ho_ten : "Chưa có thông tin"
            }
          }
          if(!this.mData.dataForm.profile.dien_thoai && this.mData.viewMode == "detail"){
            this.mData.dataForm.profile.dien_thoai = "Chưa có thông tin";
          }
          if(!this.mData.dataForm.profile.email && this.mData.viewMode == "detail"){
            this.mData.dataForm.profile.email = "Chưa có thông tin";
          }
        } else if (resKDL.result) {
          if (!avatarUrl) {
            let data = {
              id: resKDL.result.avatar_id,
              name: resKDL.result.avatar_id,
              url: avatarUrl || ExtensionService.urlImg + resKDL.result.avatar_id
            };
            this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          }
          if(resKDL.result.ho_ten && resKDL.result.ho_ten.ho_ten){
            if(resKDL.result.ho_ten.ho_ten.trim() == ""){
              resKDL.result.ho_ten.ho_ten = "Chưa có thông tin";
            }
          }else if (!resKDL.result.ho_ten) {
            resKDL.result.ho_ten = MethodService.copyObject(
              NguoiDungModel.dataForm.profile.ho_ten
            );
          }
          this.mData.dataForm.profile = resKDL.result;
          if(!this.mData.dataForm.profile.ho_ten || (!this.mData.dataForm.profile.ho_ten.ho_ten && this.mData.viewMode == "detail")){
            this.mData.dataForm.profile.ho_ten ={
              ho_ten : "Chưa có thông tin"
            }
          }
          if(!this.mData.dataForm.profile.dien_thoai && this.mData.viewMode == "detail"){
            this.mData.dataForm.profile.dien_thoai = "Chưa có thông tin";
          }
          if(!this.mData.dataForm.profile.email && this.mData.viewMode == "detail"){
            this.mData.dataForm.profile.email = "Chưa có thông tin";
          }
          console.log("this.mData.dataForm.profile",this.mData.dataForm.profile);
        } else if (resHDV.result) {
          if (!avatarUrl) {
            let data = {
              id: resHDV.result.avatar_id,
              name: resHDV.result.avatar_id,
              url: avatarUrl || ExtensionService.urlImg + resHDV.result.avatar_id
            };
            this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          }
          if (!resHDV.result.ho_ten) {
            resHDV.result.ho_ten = MethodService.copyObject(
              NguoiDungModel.dataForm.profile.ho_ten
            );
          }
          this.mData.dataForm.profile = resHDV.result;
        }
        else {
          this.mData.dataForm.profile = MethodService.copyObject(
            NguoiDungModel.dataForm.profile
          );
          this.mData.dataForm.profile.id = id;
        }
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData() {},

    async fn_initDataDefault() {
      const provinceApiReq = await ProvinceApi.list({
        limit: 100
      });
      // const districtApiReq = await DistrictApi.list({
      //   limit
      // })
      const provinceApiRes = await provinceApiReq;
      this.mData.dataDefault.listProvince = provinceApiRes.result;

      this.mData.dataDefault.listProvince.forEach(item => {
        if(item.type == "Thành phố"){
          item.name = "Thành phố "+ item.name
        }
      })
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.profile.avatar_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "nguoidung")
        .then(res => {
          this.mData.dataForm.profile.avatar_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    fn_showButtonUpdate() {
      if (
        this.mData.viewMode == "update" &&
        (MethodService.checkRole("Admin,Officer") ||
          this.mData.RecordIsCurrentUser)
      ) {
        return true;
      } else if (
        (this.mData.viewMode == "changePass" ||
          this.mData.viewMode == "changeRole") &&
        MethodService.checkRole("Admin,Officer")
      ) {
        return true;
      } else {
        return false;
      }
    },
    async fn_changeProvince(provinceId){
      console.log("provinceId",provinceId);
      if(!provinceId){
        return
      }
      const districtApiRes = await DistrictApi.list({
        limit: 100,
        filters: "provinceId="+provinceId
      });
      this.mData.dataDefault.listDistrict = districtApiRes.result;
    },
    fn_init() {
      let currentUser = MethodService.getCurrentUser();
      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-update"
      ) {
        this.mData.viewMode = "update";
        if (this.$router.currentRoute.query.viewMode == "changePass") {
          this.mData.viewMode = "changePass";
        }
        if (this.$router.currentRoute.query.viewMode == "changeRole") {
          this.mData.viewMode = "changeRole";
        }
      }
      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-detail"
      ) {
        this.mData.viewMode = "detail";
      }
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
      if (this.$router.currentRoute.params.id == currentUser.id) {
        this.mData.RecordIsCurrentUser = true;
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  },
  created: function() {
    this.fn_initDataDefault();
    this.fn_init();
  },
  mounted: function() {},
  watch: {
    '$route': 'fn_init'
  }
};
</script>
